import React, { useRef, useState } from "react";
import { StarIcon } from "lucide-react";
import { testimonials } from "../data/salesCopy";
export function Testimonials() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [active, setActive] = useState(0);
  const onScroll = () => {
    const el = trackRef.current;
    if (!el) return;
    const card = el.firstElementChild as HTMLElement | null;
    if (!card) return;
    setActive(Math.round(el.scrollLeft / (card.offsetWidth + 12)));
  };
  const goTo = (i: number) => {
    const el = trackRef.current;
    const card = el?.children[i] as HTMLElement | undefined;
    if (el && card) el.scrollTo({
      left: card.offsetLeft - el.offsetLeft - 20,
      behavior: "smooth"
    });
  };
  return <section aria-label="Testimonios de docentes" className="mx-auto max-w-6xl py-8 md:px-5 md:py-16" data-id="element-290" data-mp="2s3081h3c9cjv">
      <ul ref={trackRef} onScroll={onScroll} className="no-scrollbar flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-px-5 px-5 md:grid md:grid-cols-3 md:gap-6 md:overflow-visible md:px-0" data-id="element-291" data-mp="v8ws66kuleb4">
        {testimonials.map(t => <li key={t.name} className="w-[85%] shrink-0 snap-start md:w-auto" data-id="element-292" data-mp="m5kngsk6j1ej">
            <figure className="flex h-full flex-col rounded-2xl bg-card p-5 ring-1 ring-line md:p-6" data-id="element-293" data-mp="77s9i4ua6l2g">
              <div className="flex gap-0.5" aria-label="5 estrellas" data-id="element-294" data-mp="c6lknqm3hzzg">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-pencil text-pencil" aria-hidden="true" data-id="element-295" data-mp="zxhawjawkn4l" data-mpi={i} />)}
              </div>
              <blockquote className="mt-3 text-sm leading-relaxed md:text-[15px]" data-id="element-296" data-mp="14xluii73xxz1">"{t.quote}"</blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-4" data-id="element-297" data-mp="q4s9yiczarni">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-chalk-soft text-sm font-bold text-chalk" aria-hidden="true" data-id="element-298" data-mp="v3wl3ejgqzgh">
                  {t.name.charAt(0)}
                </span>
                <span data-id="element-299" data-mp="1no3ik9gzw5e2">
                  <span className="block text-sm font-bold" data-id="element-300" data-mp="1xhqwjkgjbkrw">{t.name}</span>
                  <span className="block text-xs text-muted" data-id="element-301" data-mp="1xfwk6ujbx0zf">{t.detail}</span>
                </span>
              </figcaption>
            </figure>
          </li>)}
      </ul>
      <div className="mt-3 flex justify-center gap-1.5 md:hidden" data-id="element-302" data-mp="1ofreqpxp4cnw">
        {testimonials.map((t, i) => <button key={t.name} type="button" onClick={() => goTo(i)} aria-label={`Ver testimonio de ${t.name}`} className={`h-1.5 rounded-full transition-[width,background-color] duration-200 ease-out ${i === active ? "w-5 bg-chalk" : "w-1.5 bg-line"}`} data-id="element-303" data-mp="1jhyc26vlq0sd" data-mpi={i} />)}
      </div>
    </section>;
}